import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import AddDeliveryWebhook from './AddDeliveryWebhook.vue';

export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/settings/kaption-delivery-webhooks'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_kaption_delivery_webhooks',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'new',
          name: 'settings_kaption_delivery_webhooks_new',
          component: AddDeliveryWebhook,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
